export default __webpack_public_path__ + "static/media/laura.872c5c84.png";